import { WorkflowState } from '@amzn/awscat-pattern-library-service-model';

import { useWorkflow } from '../v2-hooks/useWorkflow';

/** The workflow stage whose "about" content the panel should display. */
export type AboutStage = 'draft' | 'quality-check' | 'publisher-review' | 'published';

/** View model for the "About this stage" informational panel. */
export interface AboutStagePanelViewModel {
  /** Which stage's explanatory content to render. */
  readonly stage: AboutStage;
}

const publishedStates = new Set<WorkflowState>([
  WorkflowState.PUBLISHED,
  WorkflowState.FINALIZED,
  WorkflowState.DISTRIBUTED,
  WorkflowState.FINALIZING,
]);

function resolveStage(draftState: WorkflowState | undefined): AboutStage {
  if (draftState === WorkflowState.QUALITY_CHECK) return 'quality-check';
  if (draftState === WorkflowState.PUBLISHER_REVIEW) return 'publisher-review';

  // Any published-family state maps to the published about content.
  if (draftState && publishedStates.has(draftState)) return 'published';

  // Draft is the default for NEW/MODIFIED/UNMODIFIED, other states, and when no
  // workflow is loaded yet.
  return 'draft';
}

/**
 * Derives which stage's "about" content to show from the current workflow.
 * Defaults to the draft stage until a workflow is loaded.
 */
export function useAboutStagePanelViewModel(): AboutStagePanelViewModel {
  const workflow = useWorkflow();

  return { stage: resolveStage(workflow?.draftState) };
}
